import { useContext } from "react";
import { trpc } from "../../../utils/trpc";
import { useGuildMemberCache } from "./use_guild_member_cache";

export function useRSVPedUsers(
	guild_id: string,
	message_id: string,
	rsvp_option_id: string
) {
	const members_cache = useGuildMemberCache();

	const rsvpers_query = trpc.event.rsvpedUsers.useQuery(
		{
			guild_id,
			message_id,
			rsvp_option_id,
		},
		{
			onSuccess: (data) => {
				members_cache.addMembers(guild_id, data);
			},
		}
	);

	return rsvpers_query;
}
